// Angular
import { Component, Input, OnChanges } from '@angular/core';

// Afidium
import { ISummarySectorStay } from '../../../sectors/components/shared/interfaces/ISummary';
import { IGetBookingsStayResponse, IProperty } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { DatesService } from 'app_sasha/shared/services/dates/dates.service';

//libs
import { faBed, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faMoon as faMoonO } from "@fortawesome/free-regular-svg-icons";

@Component({
    selector: 'stay-summary-menu',
    template: `
        <div>
            <div class="dates">
                <div>
                    <fa-icon [icon]="iconBed" class="label-icon"></fa-icon>
                </div>
                <div class="grow">
                    <div>{{ dates.begin }}</div>
                    <div>
                        <span class="duration">{{ dates.duration }}</span>
                        <fa-icon [icon]="iconMoon"></fa-icon>
                    </div>
                </div>
            </div>

            <strong *ngIf="property?.name" class="name">{{ property.name }}</strong>
        </div>
    `,
    styles: [`
        .dates {
            display: flex;
            justify-content: space-between;
            padding-bottom: 5px;
        }

        .grow{
            flex: 1;
        }
        .label-icon {
            margin-right: .75rem;
        }
    `]
})
export class StaySummaryMenuComponent implements OnChanges {
    @Input()
    public booking: IGetBookingsStayResponse;

    @Input()
    public sector: ISummarySectorStay;

    public property: IProperty;

    public iconBed: IconDefinition = faBed;

    public iconMoon: IconDefinition = faMoonO;

    public dates: {
        begin: string;
        duration: number;
    };

    constructor(
        private readonly datesService: DatesService,
    ) {
    }


    public ngOnChanges(): void {
        this.dates = {
            begin: this.datesService.formatDate(this.sector.begin, 'momentMedium'),
            duration: this.sector.duration.night,
        };

        if (this.sector && this.booking && this.sector.property) {
            this.property = (this.booking.property || []).find((property: IProperty): boolean => property.xId === this.sector.property.xId);
        } else {
            this.property = undefined;
        }
    }
}